import React from 'react'

import {
  AddressField,
  FieldSpec,
  LinkedField,
  PaginatedTable,
  RelatedLinkedField,
  ValueField,
} from 'src/components/Table'
import {ListTableProps} from './types'

const fieldOptions: {[key: string]: FieldSpec} = {
  market: {id: 'market', label: 'Market', ordering: 'market__name', renderer: RelatedLinkedField(ValueField, 'name')},
  name: {id: 'name', label: 'Name', renderer: LinkedField(ValueField)},
  address: {id: 'address', label: 'Address', renderer: AddressField},
  phone: {id: 'phone', label: 'Phone Number', renderer: ValueField},
}

export const FacilityListTable = (props: ListTableProps) => {
  const {paginator, fields, exportConfig} = props

  return (
    <>
      <PaginatedTable
        title="Facilities"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
